import {
  DoBootstrap,
  NgModule,
} from '@angular/core';

import { PatientPortalAngularJSModule } from './ajs/ajs.module';
import { PatientPortalConfigurationRepository } from './core';
import {
  CoreModule,
  LoginModule,
  TelehealthModule,
  DashboardModule,
} from './modules.index';

import { imports as conditionalImports } from './conditional.module';

import {
  WebCommonModule,
} from 'webcommon';
import {
  WebBridgeService,
} from 'webcommon/common-api';
import {
  AprimaCacheService,
  BridgeService,
  ConfigurationRepository,
  DeviceSettingsRepository,
  LogInService,
} from 'webcommon/legacy-common';

@NgModule({
  imports: [
    WebCommonModule,
    CoreModule,
    LoginModule,
    PatientPortalAngularJSModule,
    TelehealthModule,
    DashboardModule,
    ...conditionalImports,
  ],
})
export class AppModule implements DoBootstrap {
  constructor(
    private aprimaCacheService: AprimaCacheService,
    private bridgeService: BridgeService,
    private configurationRepository: ConfigurationRepository,
    private deviceSettingsRepository: DeviceSettingsRepository,
    private logInService: LogInService,
    private portalConfigurationRepository: PatientPortalConfigurationRepository,
    private webBridgeService: WebBridgeService,
    private webCommonModule: WebCommonModule,
  ) { }

  ngDoBootstrap() {
    this.configurationRepository.loadConfiguration(this.portalConfigurationRepository);
    this.deviceSettingsRepository.loadConfiguration({
      isBrowser: true,
      isBrowserOrOverride: true,
      isDevice: false,
      isDeviceOrOverride: false,
      isPhone: false,
      isPhoneOrOverride: false,
      isTablet: false,
      isTabletOrOverride: false,

      isAndroid: false,
      isIos: false,
      isPrm: false,
      isStandaloneBrowser: true,
    });
    this.bridgeService.loadConfiguration(this.webBridgeService);
    this.aprimaCacheService.initialize();
    this.logInService.setDefaultRedirect();

    this.webCommonModule.bootstrap();
  }
}
